export default "__VITE_ASSET__276c67c8__"